module.exports = __webpack_public_path__ + "assets/689521fc86d4ff1ef21e7b15df5ac6cc.mp3";